import { EndpointsEnum } from '@/services/endpoints'
import { TmApiNeedEmailTfaError } from '@/core/error/transport/customErrors/tmApiNeedEmailTfaError'
import type { CustomErrorRule } from '@/core/error/transport/types'

export const reopenAccountNeedTFAEmailConfirmationRule: CustomErrorRule = {
  endpoint: EndpointsEnum.reopenAccount,
  klass: TmApiNeedEmailTfaError,
}
